export default function save( { attributes } ) {
	return <div style={ { height: attributes.height } } aria-hidden />;
}
